"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNSPECIFIED_UNIT = void 0;
exports.UNSPECIFIED_UNIT = 'UNSPECIFIED';
